document.addEventListener('variant:change', function(evt) {
  var vID = evt.detail.variant.id;
  var temp = vID + "-stock";
  var avail = document.getElementById(temp).getAttribute('data-avail');
  var cartBtn = document.querySelector('button.add-to-cart');
  var cartBtnText = document.querySelector('button.add-to-cart span');
  if(avail == "false"){
    cartBtn.classList.add('disabled');
              cartBtn.disabled = true;
              cartBtnText.textContent = 'Out of Stock Online';
  }
});